import { Category } from './category';

export class CategoryDto {
    constructor(public results: Category[]) {}
}
